import { Box, Typography } from '@material-ui/core'
import { useApi, useLogic, useStore } from '../../../hooks/storeHook'
import { observer } from 'mobx-react-lite'
import { useLazyEffect } from '../../../hooks/commonHooks'
import React, { useRef, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Button } from '../../shared/ui/button'
// import axios from 'axios'
// import { ImportProductCardStatistics } from '../../../server/mpsklad_core/Models/ImportProductCardStatistics'
import { CircularProgressWithLabel } from '../../shared/ui/circularProgressWithLabel'
import { LoaderWithText } from '../../shared/ui/loaderWithText'
import { integrationTypeSlugs } from '../../../types/integrationTypeUtils'
import { ImportProgressInfo } from '../../../server/mpsklad_core/Models/MpCard/ImportProgressInfo'
import { Finish } from './ui/finish'
import { IntegrationType } from '../../../server/mpsklad_core/Entity/IntegrationType'

enum ImportPhase {
  INITIAL_LOADING = 0,
  STAT_LOADING = 1,
  IMPORT_IN_PROGRESS = 2,
  READY = 3,
  FINISHED = 4
}

//If we want to use this component not only with modal windows, we need to decompose it
interface GeneralProductsImportProps {
  onClose: () => void

  onSuccess: () => void
}

export const GeneralProductsImport = observer(({onClose, onSuccess}: GeneralProductsImportProps) => {
    // const [stat, setStat] = useState<ImportProductCardStatistics | null>(null)
    const intervalRef = useRef<NodeJS.Timeout | null>(null)
    const [phase, setPhase] = useState<ImportPhase>(ImportPhase.INITIAL_LOADING)

    const [importInfo, setImportInfo] = useState<ImportProgressInfo | null>(null)

    // const mismatchData = useMemo(() => ([
    //   {label: 'Цен', value: stat?.mismatchPrice},
    //   {label: 'Артикулов', value: stat?.mismatchVendorCode},
    //   {label: 'Фотографий', value: stat?.mismatchImages}
    // ]), [stat])

    const api = useApi()
    const {showDialog} = useLogic()

    const classes = useStyles()

    const {
      homeNavRequired
    } = useStore()

    const integrationType = homeNavRequired.integrationType
    const accountId = homeNavRequired.accountId

    const cancelRequestRef = useRef<(() => void) | null>(null)

    const pollingStatus = async () => {
      if (!accountId) {
        throw new Error(`Unknown accountId`)
      }

      try {
        const stat = await api.getImportStatus(accountId, integrationTypeSlugs[integrationType])

        // Если импорт реально завершен (есть completedAt) или есть ошибка
        if ((stat.isCompleted && stat.completedAt) || stat.isError) {
          setImportInfo(stat)
          setPhase(ImportPhase.FINISHED)
          stat.isCompleted && !stat.isError && onSuccess()
          return
        }
        // Если isCompleted=true но completedAt=null - значит импорта не было, показываем READY
        else if (stat.isCompleted && !stat.completedAt) {
          setPhase(ImportPhase.READY)
          return
        }
        // Импорт в процессе
        else {
          setPhase(ImportPhase.IMPORT_IN_PROGRESS)
          setImportInfo(stat)
          intervalRef.current = setTimeout(pollingStatus, 1000)
        }
      } catch {
        throw new Error('Error fetching')
      }
    }

    const handleRetryImport = async () => {
      // Сбрасываем состояние к начальному для повторной попытки импорта
      setPhase(ImportPhase.READY)
      setImportInfo(null)
      // Очищаем интервал если он был
      if (intervalRef.current) {
        clearTimeout(intervalRef.current)
        intervalRef.current = null
      }
    }

    // const fetchImportStat = async () => {
    //   if (!accountId) {
    //     throw new Error(`Unknown accountId`)
    //   }
    //
    //   const source = axios.CancelToken.source()
    //   cancelRequestRef.current = source.cancel
    //
    //   try {
    //     const res = await api.getImportStat(accountId, integrationTypeSlugs[integrationType], {
    //       cancelToken: source.token
    //     })
    //
    //     setStat(res)
    //     setPhase(ImportPhase.READY)
    //   } catch (e) {
    //     if (axios.isCancel(e)) {
    //       throw new Error('Unable to fetch cards from API')
    //     }
    //   }
    // }

    useLazyEffect(() => {
        pollingStatus().catch(console.error)

        return () => {
          cancelRequestRef.current?.()

          if (intervalRef.current) {
            clearInterval(intervalRef.current)
          }
        }
      }
    )

    const handleStartImport = async () => {
      if (!accountId) {
        throw new Error(`Unknown accountId`)
      }

      if (await showDialog('Вы действительно хотите начать импорт?', {
        title: 'Внимание',
        acceptButton: 'Начать',
        declineButton: 'Отменить'
      })) {
        await api.startImport(accountId, integrationTypeSlugs[integrationType])
        setImportInfo(null)
        setPhase(ImportPhase.IMPORT_IN_PROGRESS)

        pollingStatus().catch(console.error)
      }
    }
    /*
        DEPRICATED UNTILL TIMEOUT FIX ON IMPORTSTATS !!!

    if (phase === ImportPhase.INITIAL_LOADING || phase === ImportPhase.STAT_LOADING) {
      return <LoaderWithText
        text={<>Получение данных может занять до 2-х минут <br/> Пожалуйста, не закрывайте это окно</>}
        className={classes.loader}>
        <CircularProgress color={'secondary'}/>
      </LoaderWithText>
    }



    if (!stat) {
      throw new Error('Unknown stat')
    }

    <Typography color={'secondary'} variant={'h5'} className={classes.title}>Импорт товаров</Typography>
      <Box className={classes.importInfo}>
        <Box className={classes.row}>
          <Box component="span">Найдено новых товаров:</Box>
          <Box component="span" className={classes.count}>
            {stat.notFoundCount}
          </Box>
        </Box>
        <Box className={classes.row}>
          <Box component="span">Обновлено товаров, в т.ч:</Box>
          <Box component="span" className={classes.count} color="secondary">
            {stat.foundCount}
          </Box>
        </Box>
        <List className={classes.list}>

          {mismatchData.map(({label, value}, index) => (
            <ListItem className={classes.listItem} key={index}>
              <Box className={classes.listContent}>
                <span className={classes.dash}>&mdash;</span>
                <span>{label}</span>
              </Box>
              <span className={classes.listCount}>{value}</span>
            </ListItem>
          ))}

        </List>
      </Box>
    */

  if (phase === ImportPhase.IMPORT_IN_PROGRESS && importInfo) {
    return <LoaderWithText text={<>{importInfo.status} <br /> Вы можете закрыть это окно</>} className={classes.loader}>
      <CircularProgressWithLabel color={'secondary'} className={classes.loader} value={importInfo.progressPercentage} />
    </LoaderWithText>
  }

  if (phase === ImportPhase.FINISHED) {
    return <Finish errorMessage={importInfo?.errorMessage} totalItems={importInfo?.totalItems ?? 0}
      handleRerunPulling={handleRetryImport} />
  }

  // Фаза READY - показываем описание и кнопки
  const getImportDescription = () => {
    if (integrationType === IntegrationType.MoySklad) {
      return 'Система загрузит актуальные данные по товарам из вашего Моего Склада.\nИмпорт может занять несколько минут - можете закрыть это окно.'
    } else {
      return 'Мы загрузим товары из подключённого магазина.\nЭто может занять несколько минут.'
    }
  }

  return <Box className={classes.wrapper}>
    <Typography color={'secondary'} variant={'h5'} className={classes.title}>Импорт товаров</Typography>
    <Box className={classes.description}>
      <Typography variant={'body1'} component={'div'} style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>
        {getImportDescription()}
      </Typography>
    </Box>
      <Box display={'flex'} justifyContent={'space-between'} marginTop={'auto'}>
        <Button className={classes.button} isCancel onClick={onClose}>Отменить</Button>
        <Button className={classes.button} onClick={handleStartImport}>Импортировать</Button>
      </Box>
    </Box>
  }
)

const useStyles = makeStyles(
  () => ({
    wrapper: {
      height: '100%',
      padding: '24px',
      boxSizing: 'border-box',
      fontSize: 24,
      display: 'flex',
      flexDirection: 'column'
    },
    loader: {
      margin: 'auto'
    },
    title: {
      margin: '0 auto'
    },
    description: {
      margin: '24px auto',
      textAlign: 'center',
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    importInfo: {
      width: 300,
      display: 'flex',
      flexDirection: 'column',
      padding: '24px 0',
      margin: 'auto'
    },
    row: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 4,
      fontSize: '1rem',
      '&:first-child': {
        marginBottom: 10
      }
    },
    count: {
      fontWeight: 600,
      color: '#2178B3',
      minWidth: 60,
      textAlign: 'right',
      fontSize: '1rem'
    },
    list: {
      display: 'flex',
      flexDirection: 'column',
      padding: '4px 0 0 12px',
      gap: 2
    },
    listItem: {
      padding: 0,
      fontSize: '0.9rem',
      color: '#727272'
    },
    listContent: {
      display: 'flex',
      alignItems: 'center',
      gap: 8
    },
    dash: {
      fontSize: '1rem',
      color: '#727272'
    },
    listCount: {
      color: '#2178B3',
      marginLeft: 'auto'
    },
    button: {
      margin: '0 !important',
      '&:first-child': {
        width: '130px !important'
      }
    }
  }))